import React from 'react';
import { Tokens } from '../../types';
import { Paragraph } from '../Typography';

import { Container, Option, SelectedCircle, SelectToggle, TextContainer } from './Radio.styles';
import { RadioProps } from './Radio.types';

/**
 *
 * @deprecated
 * previsão para ser removido na ver. 1.11.0
 */
export const Radio: React.FC<RadioProps> = ({
  options,
  selectedOptionId,
  onChange,
  style,
  buttonStyle,
}) => {
  return (
    <Container data-testid="Radio" style={style} role="tmov-radio">
      {options.map(option => (
        <Option
          type="button"
          data-testid={`option-${option.id}`}
          key={option.id}
          selected={option.id === selectedOptionId}
          onClick={() => onChange(option.id)}
          style={buttonStyle}
        >
          <TextContainer>
            <Paragraph
              style={{
                margin: 0,
                fontSize: 14,
                marginBottom: 2,
                color: Tokens.eixods.colors.neutral.grey[100],
              }}
            >
              {option.name}
            </Paragraph>
            <Paragraph
              style={{ margin: 0, fontSize: 12, color: Tokens.eixods.colors.neutral.grey[70] }}
            >
              {option.description}
            </Paragraph>
          </TextContainer>
          <SelectToggle>{option.id === selectedOptionId && <SelectedCircle />}</SelectToggle>
        </Option>
      ))}
    </Container>
  );
};
